import { ListNode, SerializedListNode } from '@lexical/list';
import { EditorConfig, NodeKey } from 'lexical';

export type SerializedCustomListNode = SerializedListNode & {
  __blockId?: string;
  Modified?: 'true' | 'false' | 'added' | 'removed';
};

export class CustomListNode extends ListNode {
  __blockId?: SerializedCustomListNode['__blockId'];
  Modified?: SerializedCustomListNode['Modified'];

  static getType(): string {
    return 'list';
  }

  static clone(node: CustomListNode): CustomListNode {
    return new CustomListNode(node.getListType(), node.getStart(), node.__blockId, node.Modified, node.__key);
  }

  constructor(listType: 'number' | 'bullet' | 'check', start: number, __blockId?: SerializedCustomListNode['__blockId'], Modified?: SerializedCustomListNode['Modified'], key?: NodeKey) {
    super(listType, start, key);

    this.__blockId = __blockId;
    this.Modified = Modified;
  }

  exportJSON(): SerializedCustomListNode {
    const json = super.exportJSON() as SerializedCustomListNode;
    if (this.__blockId) {
      json.__blockId = this.__blockId;
    }
    if (this.Modified !== undefined) {
      json.Modified = this.Modified;
    }
    return json;
  }

  static importJSON(serializedNode: SerializedCustomListNode): CustomListNode {
    const node = new CustomListNode(serializedNode.listType, serializedNode.start, serializedNode.__blockId, serializedNode.Modified);

    // Preserve formatting
    node.setFormat(serializedNode.format || '');
    node.setDirection(serializedNode.direction || null);
    node.setIndent(serializedNode.indent || 0);
    return node;
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);

    if (this.__blockId) {
      dom.setAttribute('data-block-id', this.__blockId);
    }

    if (this.Modified === 'true') {
      dom.classList.add('modified-block', 'true');
    } else if (this.Modified === 'added') {
      dom.classList.add('modified-block', 'added');
    } else if (this.Modified === 'removed') {
      dom.classList.add('modified-block', 'removed');
    }

    return dom;
  }

  static importDOM(): Record<string, any> | null {
    return {
      ol: () => ({
        conversion: () => ({ node: new CustomListNode('number', 1) }),
        priority: 1,
      }),
      ul: () => ({
        conversion: () => ({ node: new CustomListNode('bullet', 1) }),
        priority: 1,
      }),
    };
  }
}